const colors = {
    0: 'blue',
    1: 'sea',
    2: 'orange',
    3: 'magenta',
    4: 'purple',
    5: 'blue',
    6: 'sea',
    7: 'orange',
    8: 'magenta',
    9: 'purple',
    A: 'blue',
    B: 'sea',
    C: 'orange',
    D: 'magenta',
    E: 'purple',
    F: 'blue',
    G: 'blue',
    H: 'sea',
    I: 'orange',
    J: 'magenta',
    K: 'purple',
    L: 'blue',
    M: 'sea',
    N: 'orange',
    O: 'magenta',
    P: 'purple',
    Q: 'blue',
    R: 'sea',
    S: 'orange',
    T: 'magenta',
    U: 'purple',
    W: 'blue',
    V: 'blue',
    X: 'sea',
    Y: 'orange',
    Z: 'magenta'
};
export default colors;
